class HHRegisterForm extends HTMLElement {
  constructor() {
    super();

    this.$submit = this.querySelector('.js-register-submit')
    this.$registerForm = this.querySelector('#create_customer')

    this.fname = this.querySelector('#RegisterForm-FirstName')
    this.lname = this.querySelector('#RegisterForm-LastName')
    this.email = this.querySelector('#RegisterForm-email')
    this.passwd = this.querySelector('#RegisterForm-password')
    this.re_passwd = this.querySelector('#RegisterForm-confirm-password')

    this.fnameError = this.querySelector('.js-RegisterForm-FirstName')
    this.lnameError = this.querySelector('.js-RegisterForm-LastName')
    this.emailError = this.querySelector('.js-RegisterForm-email')
    this.passwdError = this.querySelector('.js-RegisterForm-password')
    this.repasswdError = this.querySelector('.js-RegisterForm-password-confirmation')
  }

  connectedCallback() {
    this.$submit.addEventListener('click', this.registerFormSubmit.bind(this))
  }

  validateEmail(elementValue) {
    const mailformat = /^\w+([+.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/
    return elementValue.match(mailformat)
  }

  registerFormSubmit(event) {
    event.preventDefault();

    let valid = true
    if (this.fname.value === '') {
      this.fnameError.classList.remove('hidden')
      this.fnameError.querySelector('.js-customer-error-wrap').focus()
      valid = false
      this.fname.classList.add('has-error')
    } else {
      this.fnameError.classList.add('hidden')
      this.fname.classList.remove('has-error')
    }

    if (this.lname.value === '') {
      this.lnameError.classList.remove('hidden')
      if (valid) {
        this.lnameError.querySelector('.js-customer-error-wrap').focus()
        valid = false
      }
      this.lname.classList.add('has-error')
    } else {
      this.lnameError.classList.add('hidden')
      this.lname.classList.remove('has-error')
    }

    if (this.email.value === '') {
      this.emailError.classList.remove('hidden')
      this.emailError.querySelectorAll('span').forEach(item => item.classList.remove('hidden'))
      if (valid) {
        this.emailError.querySelector('.js-customer-error-wrap').focus()
        valid = false
      }
      this.email.classList.add('has-error')
    } else if (this.email.value !== '' && !this.validateEmail(this.email.value)) {
      this.emailError.classList.remove('hidden')
      this.emailError.querySelectorAll('span').forEach(item => item.classList.remove('hidden'))
      this.emailError.querySelector('.js-error-required').classList.add('hidden')
      if (valid) {
        this.emailError.querySelector('.js-customer-error-wrap').focus()
        valid = false
      }
      this.email.classList.add('has-error')
    } else {
      this.emailError.classList.add('hidden')
      this.email.classList.remove('has-error')
    }

    if (this.passwd.value === '') {
      this.passwdError.classList.remove('hidden')
      if (valid) {
        this.passwdError.querySelector('.js-customer-error-wrap').focus()
        valid = false
      }
      this.passwd.classList.add('has-error')
    } else {
      this.passwdError.classList.add('hidden')
      this.passwd.classList.remove('has-error')
    }

    if (this.re_passwd?.value === '') {
      this.repasswdError.classList.remove('hidden')
      this.repasswdError.querySelectorAll('span').forEach(item => item.classList.remove('hidden'))
      this.repasswdError.querySelector('.js-error-matched').classList.add('hidden')
      if (valid) {
        this.repasswdError.querySelector('.js-customer-error-wrap').focus()
        valid = false
      }
      this.re_passwd.classList.add('has-error')
    } else if (this.passwd.value !== this.re_passwd?.value) {
      this.repasswdError.classList.remove('hidden')
      this.repasswdError.querySelectorAll('span').forEach(item => item.classList.remove('hidden'))
      this.repasswdError.querySelector('.js-error-required').classList.add('hidden')
      if (valid) {
        this.repasswdError.querySelector('.js-customer-error-wrap').focus()
        valid = false
      }
      this.re_passwd.classList.add('has-error')
    } else {
      this.repasswdError.classList.add('hidden')
      this.re_passwd.classList.remove('has-error')
    }

    if (valid) {
      this.$registerForm.submit()
    }
  }
}

customElements.define("hh-register-form", HHRegisterForm);
